import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 加载 element 组件库
import ElementUI from 'element-ui'
 
// 加载 element 组件库的样式
import 'element-ui/lib/theme-chalk/index.css'
 
// 全局注册 element 组件库
Vue.use(ElementUI)

Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.axios = axios

// 动画 animate.css
require('animate.css/animate.min.css');
// 滚动动画 wow.js
import {WOW} from 'wowjs'
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default  需要执行动画的元素的 class
  animateClass: 'animated', // default  animation.css 动画的 class
  offset: 0, // default  距离可视区域多少开始执行动画
  mobile: true, // default  是否在移动设备上执行动画
  live: false,  // 异步加载的内容是否有效
 
  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
 
  callback: function(box) {
    // console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  }

})
import { seo } from "@/api/api";
window.url = 'https://webapi.1bao1.com/'
// window.url = 'https://web.zxperson.com/'
new Vue({
  router,
  store,
  render: h => h(App),
  components: { App },
  template: '<App/>',
  data: {
    keywords: "",
    description: "",
    title: "",
    seo:[]
  },
  created() {
    
    this.getSEO()
    router.beforeEach((to, from, next) => {
      next()
      for (const key in this.seo ) {
        if(this.seo[key].router==this.$route.path){
          this.keywords = this.seo[key].keyword;
          this.description = this.seo[key].description;
          this.title = this.seo[key].title;
        }
      }
      if(this.$route.path!='/schoolDetails'){
        document.title = this.title;
        document.querySelector('meta[name="keywords"]').setAttribute('content', this.keywords)
        document.querySelector('meta[name="description"]').setAttribute('content', this.description)
      }
    })
  },
  methods: {
      //获取seo
      getSEO() {
          seo().then((res) => {
            
            this.seo = res.data.data
            for (const key in this.seo ) {
              if(this.seo[key].router==this.$route.path){
                this.keywords = res.data.data[key].keyword;
                this.description = res.data.data[key].description;
                this.title = res.data.data[key].title;
              }
            }
            if(this.$route.path!='/schoolDetails'){
              document.title = this.title;
              document.querySelector('meta[name="keywords"]').setAttribute('content', this.keywords)
              document.querySelector('meta[name="description"]').setAttribute('content', this.description)
            }
          })
      }
  }
}).$mount('#app')
